/* eslint-disable i18next/no-literal-string -- not visible to user */
import { defineSlotRecipe } from '@chakra-ui/react';

export const tooltip = defineSlotRecipe({
  slots: ['content', 'arrow', 'arrowTip'],
  className: 'chakra-tooltip',
  base: {
    content: {
      '--tooltip-bg': 'colors.bg.inverted',
      fontWeight: 'medium',
      textStyle: 'xs',
      maxW: 'xs',
      zIndex: 'tooltip',
      transformOrigin: 'var(--transform-origin)',
      _open: {
        animationStyle: 'scale-fade-in',
        animationDuration: 'fast',
      },
      _closed: {
        animationStyle: 'scale-fade-out',
        animationDuration: 'fast',
      },

      bg: 'gray.25',
      color: 'on-navy.500',
      px: 3,
      py: 3,
      borderWidth: 1,
      borderColor: 'gray.200',
      borderRadius: 4,
      boxShadow: 'lg',
    },
    arrow: {
      '--arrow-size': 'sizes.2',
      '--arrow-background': 'var(--tooltip-bg)',
    },
    arrowTip: {
      borderTopWidth: '1px',
      borderInlineStartWidth: '1px',
      borderColor: 'var(--tooltip-bg)',
    },
  },
  variants: {
    size: {
      md: {
        content: {
          maxWidth: '320px',
        },
      },
      lg: {
        content: {
          maxWidth: '480px',
        },
      },
    },
  },

  defaultVariants: {
    size: 'md',
  },
});
